"use client";

import { useState } from "react";
import ENDPOINTS from "@/lib/endpoints";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { request } from "@/lib/helpers";
import useUtility from "@/app/_hooks/useUtility";

export default function useSubscribe() {
  const { trans } = useUtility();
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Validation Schema
  const SubscribeSchema = Yup.object().shape({
    email: Yup.string()
      .email(trans("Invalid email address"))
      .required(trans("Email is required")),
  });

  // Form Submission Handler
  const handleSubscribe = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const { data } = await request.post(ENDPOINTS.SUBSCRIBE, values);

      if (data.status === "success") {
        toast.success(trans(data.message?.[0] || "Subscribed successfully!")); // Use the first success message
        resetForm();
      } else if (data.status === "error") {
        if (data.remark === "validation_error" && data.message?.error) {
          // Display each validation error
          data.message.error.forEach((err) => toast.error(trans(err)));
        } else {
          toast.error(
            trans(data.message?.[0] || "Subscription failed. Try again."),
          );
        }
      }
    } catch (error) {
      console.error("Subscribe API Error:", error);
      toast.error(
        trans("An error occurred while subscribing. Please try again later."),
      );
    }
    setIsSubmitting(false);
  };

  return { isSubmitting, SubscribeSchema, handleSubscribe };
}
